import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\n\tbottom: 0;\n\tleft: 0;\n\topacity: 0;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\ttransition: opacity ", " linear;\n\n\tinput:checked + & {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\n\tappearance: none;\n\tbox-shadow: ", ";\n\tcursor: pointer;\n\tdisplay: block;\n\theight: ", ";\n\tline-height: 0;\n\tmargin: 0;\n\tmin-height: ", ";\n\tmin-width: ", ";\n\toutline: none;\n\tpadding: 0;\n\ttransition: background ", " linear;\n\twidth: ", ";\n\n\t&::before,\n\t&::after {\n\t\tdisplay: none;\n\t}\n\n\t&:focus {\n\t\t", ";\n\t}\n\n\t&:checked {\n\t\t", ";\n\t\t", ";\n\t}\n\n\t&:disabled {\n\t\t", ";\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tdisplay: inline-flex;\n\theight: ", ";\n\tposition: relative;\n\tvertical-align: middle;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var CheckboxWrapper = css(_templateObject(), ui.alignment.content.center, ui.get('controlHeight'));
export var CheckboxWrapperView = styled.div(_templateObject2(), CheckboxWrapper);
export var Checkbox = css(_templateObject3(), ui.border.control.subtle, ui.borderRadius.round, ui.get('checkboxBoxShadow'), ui.get('checkboxSize'), ui.get('checkboxSize'), ui.get('checkboxSize'), ui.get('transitionDurationFastest'), ui.get('checkboxSize'), ui.border.control.focus, ui.background.admin, ui.border.control.focus, ui.opacity.muted);
export var CheckboxIcon = css(_templateObject4(), ui.font.color.white, ui.alignment.content.center, ui.get('transitionDurationFastest'));
export var CheckboxIconView = styled.div(_templateObject5(), CheckboxIcon);